// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"u2","title":"u3","notSelected":"u4","duration":"u5","image":"u6","infoWrapper":"u7","description":"u8"};